export default "__VITE_ASSET__vXgrZZ5h__"